import { TextField, SelectField, EmailField, DateField, NumberField, FunctionField, RaRecord, useLocaleState, FunctionFieldProps } from 'react-admin'
import { Box, Typography, TypographyProps, styled } from '@mui/material'
import { branchConfigTimeConverter } from '../../../utils/times'

export const Heading: React.FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography variant='h6' sx={{ color: '#ADB3BD', fontWeight: 'normal' }} {...props}>
      {children}
    </Typography>
  )
}

export interface BookingTimeFieldProps extends Omit<FunctionFieldProps, 'render'> {
  format?: string
  source: string
  showTime?: boolean
}

// Define the styled version of FunctionField
const FunctionFieldStyled = styled(FunctionField)(({ theme }) => ({
  color: '#000000',
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}));

// Define the BookingTimeField component using the styled version
export const BookingTimeField: React.FC<BookingTimeFieldProps> = ({
  source,
  showTime = false,
  ...props
}) => {
  const [activeLocale] = useLocaleState();

  const render = (record: RaRecord): string => {
    if (!record || record[source] === undefined) return null;
    const convertOpenTime = record[source];
    const time = branchConfigTimeConverter(convertOpenTime);
    return activeLocale === 'th'
      ? time.locale('th').format(showTime ? 'HH:mm น.' : '')
      : time.format(showTime ? 'HH:mm' : '');
  };

  return <FunctionFieldStyled render={render} {...props} />;
};

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  color: '#000000',
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}))

export const EmailFieldStyled = styled(EmailField)(({ theme }) => ({
    color: '#000000',
    fontWeight: 'normal',
    fontSize: theme.typography.subtitle1.fontSize,
  }))

export const DateFieldStyled = styled(DateField)(({ theme }) => ({
    color: '#000000',
    fontWeight: 'normal',
    fontSize: theme.typography.subtitle1.fontSize,
  }))

export const NumberFieldStyled = styled(NumberField)(({ theme }) => ({
    color: '#000000',
    fontWeight: 'normal',
    fontSize: theme.typography.subtitle1.fontSize,
  }))

export const SelectFieldStyled = styled(SelectField)(({ theme }) => ({
  color: '#000000',
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}))

export const ContentWrapper = styled(Box)(() => ({ display: 'block', mb: 3 }))
